import MatchPageUI from '../../../../dictionaries/MatchPageUI.dic';
import {
  Arr
} from '../../../../lib/Array.lib';
import {
  getMatchEntities,
  isJobBlackListed,
  jobContainConstraints
} from '../MatchList.lib';

export default function getJobLabels(props) {
  const {
    job = {},
    candidate = {}
  } = getMatchEntities(props);
  const { account: recruiter = {} } = candidate;
  const isCandidateHired = (candidate = {}) => {
    if (!!Arr(candidate.engagements).length) {
      let foo = candidate.engagements.filter((eng) => eng.stage === "Guarantee");
      if (foo.length !== 0) { return true; }
    }
    return false;
  };
  let jobTypes = [];
  if (jobContainConstraints(job, candidate, "jobsPermitted")) {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.jobsPermitted.label
    );
  }
  if (jobContainConstraints(job, candidate, "jobsPitched")) {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.jobsPitched.label
    );
  }
  if (jobContainConstraints(job, candidate, "jobsDeclined")) {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.jobsDeclined.label
    );
  }
  if (isJobBlackListed(job, candidate)) {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.jobBlackListed.label
    );
  }
  else if (isCandidateHired(candidate)) {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.candidateHired.label
    );
  }
  else if (recruiter.role === "LimitedRecruiter") {
    jobTypes.push(
      MatchPageUI.CardChipBar.JobStatus.limitedRecruiter.label
    );
  }
  return jobTypes;
}
